import React from 'react';
import PropTypes from 'prop-types';
import bem from 'helpers/bem';
import { Switch } from 'components/shared';

const propTypes = {
  recurring: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

function RecurringToggle({ recurring, onChange }) {
  return (
    <div className={bem('AddToCart__RecurringToggle', { isOn: recurring })}>
      <button onClick={onChange} className="AddToCart__RecurringToggleLabel">
        Monthly Auto Renew
      </button>

      <div className="AddToCart__RecurringToggleSwitch">
        <Switch name="recurring" isChecked={recurring} onToggle={onChange} />
      </div>
    </div>
  );
}

RecurringToggle.propTypes = propTypes;

export default RecurringToggle;



// WEBPACK FOOTER //
// ./src/components/shared/RecurringToggle/RecurringToggle.jsx